import { createAsyncThunk } from '@reduxjs/toolkit';
import superagent from '@ott/superagent';
import checkAjaxError from '@ott/helper-check-ajax-error';

import makeCustomerCareInfo from '../../helpers/customerCare';

import { STATUS_CODES, ERROR_CODES } from '../../../../constants';

import { Payload, Response } from './types';
import { AuthError } from '../../types';
import { registerSuccessEvent, userExistsEvent } from '../../helpers/events';

export const register = createAsyncThunk<Response | undefined, Payload, { rejectValue: AuthError }>(
  'auth/register/fetch',
  async ({ email, password, password2, phone, reqHost = '' }, { rejectWithValue }) => {
    const url = `${reqHost}/_auth/register/by-email`;
    const data = {
      phone,
      email,
      password,
      confirmPassword: password2,
    };
    const customerInfo = makeCustomerCareInfo({
      url,
      params: data,
      step: 'auth',
    });

    try {
      const response = await superagent.post(url).type('form').send(data).withCredentials();

      const body = response.body as Response;

      if (body && body.error) {
        return rejectWithValue({
          data: {
            ...body,
            customerInfo,
          },
        });
      }

      registerSuccessEvent();

      return body;
    } catch (err: any) {
      if (err?.response?.body?.error === ERROR_CODES.EMAIL_EXISTS) {
        userExistsEvent('Auth_Popup_NewUser_Register_Click');
      }

      if (err && err?.status === STATUS_CODES.UNPROCESSABLE_ENTITY) {
        return rejectWithValue({
          data: {
            ...err.response.body,
            customerInfo,
          },
        });
      }

      return rejectWithValue({ data: checkAjaxError(err, customerInfo) });
    }
  }
);
